import './Promo.scss';
import { ClaimPromoModal } from "./components/claim-promo-modal/ClaimPromoModal";
import { PromoButton } from "./components/promo-button/PromoButton";
import { promoStore } from "../../../platform/stores";
import { observer } from "mobx-react";

export const Promo = observer(() => {
  return (
    <div className="promo">
      <PromoButton/>
      {promoStore.promoModalIsOpen && (<ClaimPromoModal/>)}
    </div>
  );
});